.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.name {
  font-size: 18px;
  font-weight: 600;
}

/* Not started is the quiet grey; a draft is lilac, the colour of what only
 * the patient can see. */
.chip {
  padding: 4px 10px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.new {
  background: var(--sunk);
  color: var(--ink-2);
}

.draft {
  background: var(--private);
  color: var(--private-ink);
}

.meta {
  font-size: 14px;
  color: var(--ink-2);
}

.instructions {
  padding: 12px 14px;
  border-radius: var(--radius-control);
  background: var(--sunk);
  font-size: 14px;
  line-height: 1.5;
}

/* Pinned to the card's bottom, so side by side on a desktop the actions
 * line up even when one card has no instructions. */
.footer {
  display: flex;
  margin-top: auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.progress {
  font-size: 13px;
  color: var(--ink-3);
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
